module.exports = __webpack_public_path__ + "img/9788958073536.d0fed084.jpg";